import { connect } from 'react-redux';

import { Dispatch } from 'redux';
import { ApplicationState } from '../../../../store';
import ScheduledInterviews, { IDispatchProps, IProps } from './index';
import { EventSystemStatus, IMessage, SectionStatusType } from 'api-paths-cas';
import { getUniRegionInterviewConfig } from '../../../../store/config/actions';
import { getUniEventTypesRecords } from '../../../../store/event_types/actions';
import { IEventType } from '../../../../store/event_types/types';
import {
  saveMessage,
  getStudentRecordedInterviews,
  getStudentCalendlyEvents,
  onRequestRecordedInterview,
  requestScheduledInterview,
  cancelScheduledInterview,
  cancelRecordedInterview,
  failScheduledInterview,
  resitScheduledInterview,
  passScheduledInterview,
} from '../../../../store/student/actions';
import { openUploadInterviewModal, openUploadRecordedInterviewModal, closeModal } from '../../../../store/ui/actions';
import { getDisplayCalendlyInterviewsAllowed, getDisplayRecordedInterviewAllowed } from '../../../../utilities/helpers';
import { hasScheduledCalendlyInterviews, hasScheduledRecordedInterviews } from '../container';

interface OwnProps {
  id: any;
}

const mapStateToProps = (state: ApplicationState): IProps => {
  const { student, auth, eventTypes, ui } = state;

  const isPathway = !!state.auth.isPathway;
  const isPathwayStudent = !!state.student.core.pathway;
  const calendlyEvents = state.student.calendlyEvents ?? [];
  const recordedInterviews = (state.student.offer as any).recordedInterviews ?? {};

  const displayCalendlyInterviewsAllowed =
    state.data.isConfigLoaded &&
    state.data.isStudentLoaded &&
    getDisplayCalendlyInterviewsAllowed(
      state.auth.role,
      isPathway,
      isPathwayStudent,
      state.config.relatedPathwaySettings,
    );

  let isScheduledInterviewsHidden = true;
  if (displayCalendlyInterviewsAllowed) {
    isScheduledInterviewsHidden =
      state.student.config?.scheduledInterviewsSectionStatus === SectionStatusType.INACTIVE &&
      !hasScheduledCalendlyInterviews(calendlyEvents);
  }

  const displayRecordedInterviewsAllowed =
    state.data.isConfigLoaded &&
    state.data.isStudentLoaded &&
    getDisplayRecordedInterviewAllowed(
      state.auth.role,
      isPathway,
      isPathwayStudent,
      state.config.relatedPathwaySettings,
    );

  let isRecordedInterviewHidden = true;
  if (displayRecordedInterviewsAllowed) {
    isRecordedInterviewHidden =
      displayRecordedInterviewsAllowed &&
      state.student.config?.recordedInterviewSectionStatus === SectionStatusType.INACTIVE &&
      !hasScheduledRecordedInterviews(recordedInterviews);
  }

  return {
    calendlyEvents,
    personalInfo: student.personalInfo,
    core: student.core,
    importData: student.importData,
    userRole: auth.role,
    eventTypes,
    uploadModal: ui.openModal,
    isScheduledInterviewsHidden,
    isRecordedInterviewHidden,
  };
};

// eslint-disable-next-line no-empty-pattern
const mapDispatchToProps = (dispatch: Dispatch, {}: OwnProps): IDispatchProps => ({
  getUniEventTypes: () => dispatch(getUniEventTypesRecords()),
  getUniRegionInterviewConfig: (uniId: string, pathway?: string) =>
    dispatch(getUniRegionInterviewConfig(uniId, pathway)),
  onSubmitMessage: (message: IMessage) => dispatch(saveMessage(message)),
  openUploadDocumentModal: (
    interviewType: string,
    eventType: string,
    eventKey: string,
    modalTitle: string,
    fileNames: string[],
  ) => {
    dispatch(openUploadInterviewModal(interviewType, eventType, eventKey, modalTitle, fileNames));
  },
  openUploadRecordedInterviewModal: (
    interviewType: string,
    interviewHash: string,
    attemptHash: string,
    modalTitle: string,
    fileNames: string[],
  ) => {
    dispatch(openUploadRecordedInterviewModal(interviewType, interviewHash, attemptHash, modalTitle, fileNames));
  },

  closeUploadDocumentModal: () => {
    dispatch(closeModal());
  },
  onGetRecordedInterviews: () => {
    dispatch(getStudentRecordedInterviews());
  },
  onGetCalendlyEvents: () => {
    dispatch(getStudentCalendlyEvents());
  },
  onRequestRecordedInterview: (interviewId: string, note: string) =>
    dispatch(onRequestRecordedInterview(interviewId, note)),
  onRequestInterview: (eventType: IEventType) => dispatch(requestScheduledInterview(eventType)),
  onCancelInterview: (eventTypeId: string, eventKey: string, note: string) =>
    dispatch(cancelScheduledInterview(eventTypeId, eventKey, note)),
  onCancelRecordedInterview: (interviewHash: string, note: string) =>
    dispatch(cancelRecordedInterview(interviewHash, note)),
  onFailInterview: (eventTypeId: string, eventName: string, eventKey: string, note: string, rescind?: boolean) =>
    dispatch(failScheduledInterview(eventTypeId, eventName, eventKey, note, rescind)),
  onResitInterview: (
    eventTypeId: string,
    eventName: string,
    eventKey: string,
    note: string,
    rescind?: boolean,
    newCalendlyInterview?: IEventType,
    sourceComponentId?: string,
  ) =>
    dispatch(
      resitScheduledInterview(eventTypeId, eventName, eventKey, note, rescind, newCalendlyInterview, sourceComponentId),
    ),
  onPassInterview: (
    eventTypeId: string,
    eventName: string,
    eventKey: string,
    status?: EventSystemStatus,
    sourceComponentId?: string,
  ) => dispatch(passScheduledInterview(eventTypeId, eventName, eventKey, status, sourceComponentId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ScheduledInterviews);
